import React, { useState, useRef } from "react";
import Layout from "../layouts/Layout";
import emailjs from '@emailjs/browser';
import "../styles/ContactUs.css"; // Reuse or update as needed

const ContactUs = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    emailjs
      .sendForm('service_6rh69eq', 'template_f488wfo', form.current, {
        publicKey: 'RkHVROSis9pCvpCF3',
      })
      .then(
        () => {
          setStatus('Message sent successfully!');
          form.current.reset(); // Clear form
        },
        (error) => {
          setStatus(`Failed to send: ${error.text}`);
        },
      );
  };

  return (
    <Layout featureType="contact_us">
      <h2>Contact Us</h2>
      <p>Get in touch with Crich Baptist Church.</p>
      <p>Email: Crichbaptist@gmail.com</p>
      {/* <p>Phone: +44 1234 567890</p> */}
      <p>Address: Market Place, Crich, Derbyshire, DE4 5DD</p>
      <form ref={form} onSubmit={sendEmail}>
        <label>Name:</label>
        <input type="text" name="user_name" required />
        <label>Email:</label>
        <input type="email" name="user_email" required />
        <label>Subject:</label>
        <input type="text" name="title" required />
        <label>Message:</label>
        <textarea name="message" required />
        <button type="submit">Send</button>
      </form>
      {status && <p>{status}</p>}
    </Layout>
  );
};

export default ContactUs;